export default function sendErrorLog(error: Error) {
  console.error(error)
}
